export default __webpack_public_path__ + "static/person_2-ed0ae7156a0d7cc8430eeda306b4510d.png";